@if (isLoading) {
  <div class="xi-loader-container__center">
    <xi-animation [loop]="true" animation="cx_loader"></xi-animation>
  </div>
}
@if (hasInvalidComparison && !isLoading) {
  <div class="text-center">
    <h1>
      {{ 'widgets.has-invalid-comparison' | transloco }}
    </h1>
  </div>
}
@if (!hasInvalidComparison) {
  <div #elementContent [class.hide]="isLoading" class="content">
    <app-document-list
      #elementData
      [options]="{
        collection: { collectionName: payload.collectionName, projectId: dashboard.project_id },
        widgetDataSource: widgetDataSource,
        query: calculatedQuery,
        sentimentScale: dashboard.payload.sentimentScale,
        sentimentDisplay: dashboard.payload.sentimentDisplay,
        dashboardId: dashboard.id,
        isDashboardLocked: dashboard.locked,
        displayColumns: payload.displayColumns,
        customItems: isCustomDocumentList,
        pageSize: payload.pageSize,
        widgetPayload: payload,
        dataSourceNotFound: dataSourceNotFound,
      }"
      (refreshDashboard)="onRefreshDashboard()"
      (filteredDocumentCountChange)="filteredDocumentCount = $event"
      (loadingFinished)="onLoadingFinished($event)"
      (loadingStarted)="onLoadingStarted($event)"
      (pageSizeChange)="payload.pageSize = $event"
      (recalculateQuery)="onRecalculateQuery($event)"
    ></app-document-list>
  </div>
}
